import Api from "./Api";
export default {
    getDataMappingFilesByDataCollectionGrid(payload) {
        return Api().get(`/data-collections/${payload.companyId}/${payload.id}/mapping-sessions`);
    },
    getDataMappingFilesGrid(payload) {
        return Api().get(`/mapping-sessions/${payload.companyId}`);
    },
    getFileDataMappingGrid(payload) {
        return Api().get(`/mapping-session/${payload.companyId}/${payload.id}`);
    },
    getDataMappingStaticKeys(companyId) {
        return Api().get(`/data-mapping-keys/${companyId}`);
    },
    getDataMappingSimilarStaticKeys(companyId) {
        return Api().get(`/data-mapping-similar-keys/${companyId}`);
    },
    getDataMappingSchemaKeys(companyId) {
        return Api().get(`/mapping-schema-fields/${companyId}`);
    },
    getDataMappingSessionFields(payload) {
        return Api().get(`/mapping-session/${payload.companyId}/${payload.sessionId}/source-fields`);
    },
    addDataMapping(payload) {
        return Api().post(`/data-collections/mappings`, payload);
    },
    editDataMapping(payload) {
        return Api().put(`/mappings/${payload.companyId}/${payload.sessionId}`, {mappings : payload.items});
    },
    getDataMapping(payload) {
        return Api().put(`/data-collections/${payload.companyId}/${payload.id}`);
    },
    deleteDataMapping(payload) {
        return Api().delete(`/data-collections/${payload.companyId}/${payload.id}`);
    },
    deleteFileDataMapping(payload) {
        return Api().delete(`/mapping-session/${payload.companyId}/${payload.sessionId}`);
    },
    deleteFileDataMappingRow(payload) {
        return Api().delete(`/mappings/${payload.companyId}/${payload.sessionId}/${payload.id}`);
    },
    generateFileDataMapping(payload) {
        return Api().post(`/mapping-sessions/${payload.companyId}/${payload.sessionId}/generate-final-json`);
    },
};
